import { Component, Injectable, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChange } from '@angular/core';

@Component({
    selector: 'pagination',
    template: require('./PaginatorComponent.html'),
    styles: [require('./PaginatorComponent.sass')]
})

@Injectable()
export class PaginatorComponent implements OnInit, OnChanges {
    @Input('currentPage') currentPage: number;
    @Input('totalPage') totalPage: number;
    @Input('numberDisplay') numberDisplay: number;
    @Output() currentPageUpdated = new EventEmitter();

    private pageList: number[];
    private oldTotalPage: number;
    ngOnInit() {
        if(this.currentPage > this.totalPage) {
            this.currentPage = 1;
        }

        this.oldTotalPage = this.totalPage;
        // Generate page number range list that will be used to display.
        this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
    }

    ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
        
        for(let propName in changes) {
            if(propName === 'totalPage' && changes[propName].currentValue > 0) {
                // Re-generate page number range list that will be used to display.
                this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
            }
            if(propName === 'currentPage') {
                if(this.pageList && this.pageList.indexOf(changes[propName].currentValue) === -1 ) {
                    // Re-generate page number range list that will be used to display.
                    this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
                }
            } 
        }
    }
    
    private generatePageNumberList(numberDisplay: number, currentPage: number, totalPage: number): number[] {
        let pageNumberList: number[] = [];
        let range = Math.floor(numberDisplay/2);
        let start = 0;
        let end = currentPage + range > totalPage ? totalPage : currentPage + range;

        // Generate start number
        if(currentPage - range > 0) {
            start = currentPage + range > totalPage ? totalPage - numberDisplay + 1 : currentPage - range;
            start = start < 1 ? start = 1: start;
        }
        else {
            start = 1;
        }

        // Generate end number
        end = start + numberDisplay - 1 > totalPage ? totalPage : start + numberDisplay - 1;

        for(start; start <= end ; start++) {
            pageNumberList.push(start);
        }
        
        return pageNumberList;
    }

    private updateSelectedPage(page: number) {
        if(page > 0 && page <= this.totalPage) {
            // Update current Page
            this.currentPage = page;

            // generate new page list
            this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);

            // Fire event for parent component to know current page had been changed
            this.currentPageUpdated.emit(page);
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/shared/components/paginator/PaginatorComponent.ts